import React from 'react';
import cn from 'classnames';

import './skeleton.scss';

export const Skeleton = ({ className }: { className?: string }) => (
  <div className={cn('skeleton', className)} />
);
